import { useQuery } from '@tanstack/react-query';
import { getInsuranceCompanies, getInsuranceCompaniesDetails, GetInsuranceCompaniesInput, getInsuranceCompaniesStates, getInsuranceCompaniesSupportedByProviderAndPatient } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const useInsuranceCompaniesQuery = (data: GetInsuranceCompaniesInput = {}, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'insuranceCompanies', data ],
    queryFn: async () => {
      const insuranceCompanies = await getInsuranceCompanies(data);

      return insuranceCompanies.data;
    },
    ...opts,
  });
};


export const useInsuranceCompaniesStatesQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'insuranceCompanies', 'states' ],
    queryFn: async() => {
      const insuranceCompanies = await getInsuranceCompaniesStates();

      return insuranceCompanies.data;
    },
    ...opts,
  });
};


export const useInsuranceCompaniesDetailsQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'insuranceCompanies', 'details' ],
    queryFn: getInsuranceCompaniesDetails,
    select: response => response.data.reduce((acc, company) => ({ ...acc, [ company.insuranceCompanyId ]: company }), {}),
    ...opts,
  });
};


export const useInsuranceCompaniesSupportedByProviderAndPatientQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'provider', providerId, 'insuranceCompanies' ],
    queryFn: async () => {
      const response = await getInsuranceCompaniesSupportedByProviderAndPatient(providerId);

      return response.data;
    },
    ...opts,
  });
};
